module.exports = __webpack_public_path__ + "static/media/3 billy the kid cowboy wildwest.1280x1784.e5b48800.webp";